import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_attribute_value = _resolveComponent("attribute-value")!

  return (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.attributeData, (attribute, key) => {
    return (_openBlock(), _createBlock(_component_attribute_value, {
      key: key,
      "attr-id": key,
      attrData: attribute
    }, null, 8, ["attr-id", "attrData"]))
  }), 128))
}